module.exports = "/public/images/d39b11e3b84b08abdecb7017899519e1.svg";